module.exports = __webpack_public_path__ + "img/123.775faa30.jpg";